.mo-button-complex {
  all: unset;
  font-family: 'Benton-Bold';
  background: #073382;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
  width: 280px;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
}

.mo-button-complex.product {
  width: 120px;
  padding: 5px 0;
  background: transparent;
  border: 1px solid #9930E2;
  color: #9930E2;
}
.mo-button-complex.header {
  font-size: 12px;
  width: 146px;
  padding: 6px;
}

.mo-button-complex.checkout {
  all: unset;
  font-family: 'Benton-Bold';
  background: #9930E2;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
}

.mo-button-complex.product:hover {
  width: 120px;
  padding: 5px 0;
  background: #9930E2;
  border: 1px solid #9930E2;
  color: #ffffff;
}

.mo-button-simple {
  all: unset;
  font-family: 'Benton-Bold';
  color: #08E8DE;
  cursor: pointer;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .mo-button-complex {
    width: 90%;
  }
  .mo-button-complex.header {
    width: 106px;
  }
}

